class QkFacetApplyButton extends HTMLButtonElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    this.countElement = this.querySelector("[data-qk-facet-apply-count]");
    this.baseline = this.formSignature;

    this.form?.addEventListener("change", () => this.updateState(), {
      signal: this.abortController.signal,
    });
    this.form?.addEventListener("input", () => this.updateState(), {
      signal: this.abortController.signal,
    });
    this.addEventListener("click", () => this.applyChanges(), {
      signal: this.abortController.signal,
    });

    this.updateState();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  get formSignature() {
    if (!this.form) return "";

    return Array.from(new FormData(this.form).entries())
      .map(([name, value]) => `${name}=${value}`)
      .sort()
      .join("&");
  }

  get selectedFilterCount() {
    if (!this.form) return 0;

    let count = 0;
    let hasPriceRange = false;

    for (const [name, value] of new FormData(this.form).entries()) {
      if (!name.startsWith("filter.") || value === "") continue;

      if (name === "filter.v.price.gte" || name === "filter.v.price.lte") {
        hasPriceRange = true;
      } else {
        count += 1;
      }
    }

    return count + (hasPriceRange ? 1 : 0);
  }

  updateState() {
    const isDirty = this.formSignature !== this.baseline;
    const filterCount = this.selectedFilterCount;

    this.disabled = !isDirty;
    this.setAttribute("aria-disabled", String(!isDirty));
    this.classList.toggle("is-dirty", isDirty);

    if (this.countElement) {
      this.countElement.textContent = isDirty && filterCount > 0 ? ` (${filterCount})` : "";
    }
  }

  applyChanges() {
    if (this.disabled) return;
    this.closest("facet-drawer")?.hide();
  }
}

if (!customElements.get("qk-facet-apply-button")) {
  customElements.define("qk-facet-apply-button", QkFacetApplyButton, { extends: "button" });
}
